import { useLocalizedStringFormatter } from '@coursera/cds-common';

import type { ValidationStatus } from '@core/forms/FormControl';
import i18nMessages from '@core/forms/i18n';

export default function useValidationAriaLabel(
  label?: string,
  validationStatus?: ValidationStatus
): string | undefined {
  const stringFormatter = useLocalizedStringFormatter(i18nMessages);

  if (!label || !validationStatus) {
    return undefined;
  }

  const statusLabelMap: Record<NonNullable<ValidationStatus>, string> = {
    success: stringFormatter.format('success', { label }),
    error: stringFormatter.format('error', { label }),
  };

  return statusLabelMap[validationStatus];
}
